import { Component, ChangeDetectionStrategy, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { BadgeMap, Company } from '@warema/shared/models';
import { SharedSvgModule } from '@warema/shared/svg';

@Component({
    selector: 'warema-company-badges',
    templateUrl: './company-badges.component.html',
    styleUrls: ['./company-badges.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [TranslatePipe, SharedSvgModule],
})
export class CompanyBadgesComponent {
    public readonly company = input.required<Company>();

    public readonly badgeMap = BadgeMap;
}
